export default {
  init() {
    $(".timeline-item").on("mouseover", function() {
		$(this)
			.addClass("current")
			.siblings()
			.removeClass("current");
	});
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/about.js